import type React from 'react';
import { BORDERS, SPACING } from '../../../../constants/design';
import { useColors } from '../../../../contexts/ThemeContext';

interface LayoutPreviewProps {
  type: 'vertical' | 'mini' | 'horizontal';
  size?: number;
}

export const LayoutPreview: React.FC<LayoutPreviewProps> = ({ type, size = 48 }) => {
  const tokens = useColors();

  const getPreviewContent = () => {
    switch (type) {
      case 'vertical':
        return (
          <div style={{ display: 'flex', height: '100%', gap: 2 }}>
            <div
              style={{
                width: '32%',
                background: tokens.primary[100],
                borderRadius: BORDERS.radius.sm,
                border: `${BORDERS.width.thin} solid ${tokens.primary[300]}`,
                minHeight: 20,
              }}
            />
            <div
              style={{
                flex: 1,
                background: tokens.surface.hover,
                borderRadius: BORDERS.radius.sm,
                border: `${BORDERS.width.thin} solid ${tokens.border.primary}`,
                minHeight: 20,
              }}
            />
          </div>
        );
      case 'mini':
        return (
          <div style={{ display: 'flex', height: '100%', gap: 2 }}>
            <div
              style={{
                width: '20%',
                background: tokens.primary[100],
                borderRadius: BORDERS.radius.sm,
                border: `${BORDERS.width.thin} solid ${tokens.primary[300]}`,
                minHeight: 20,
              }}
            />
            <div
              style={{
                flex: 1,
                background: tokens.surface.hover,
                borderRadius: BORDERS.radius.sm,
                border: `${BORDERS.width.thin} solid ${tokens.border.primary}`,
                minHeight: 20,
              }}
            />
          </div>
        );
      case 'horizontal':
        return (
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>
            <div
              style={{
                height: '28%',
                background: tokens.primary[100],
                borderRadius: BORDERS.radius.sm,
                border: `${BORDERS.width.thin} solid ${tokens.primary[300]}`,
                minHeight: 12,
              }}
            />
            <div
              style={{
                flex: 1,
                background: tokens.surface.hover,
                borderRadius: BORDERS.radius.sm,
                border: `${BORDERS.width.thin} solid ${tokens.border.primary}`,
                minHeight: 20,
              }}
            />
          </div>
        );
    }
  };

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        padding: SPACING.xs,
        border: `${BORDERS.width.thin} solid ${tokens.border.primary}`,
        borderRadius: BORDERS.radius.sm,
        background: tokens.surface.container,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        flexShrink: 0,
      }}
    >
      {getPreviewContent()}
    </div>
  );
};
